var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart-container"},[_c('div',{staticClass:"title-bar"},[_vm._v("各乡镇产量")]),_c('div',{ref:"barChartRef",staticClass:"chart-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }